import type { OrganizationSubscription, Subscription } from "@packages/client";

const useBlackFireSellableStatus = (
  subscription?: OrganizationSubscription | Subscription
) => {
  // enterprise customer will have observability_suite
  // while others will have blackfire entry that is not empty
  const isPurchased = !!(
    subscription?.blackfire || subscription?.observability_suite
  );

  const observabilityIsEnabled =
    subscription?.project_options?.sellables?.observability_suite?.available;

  const blackfireOrObservabilityIsAvailable =
    observabilityIsEnabled ||
    subscription?.project_options?.sellables?.blackfire?.available;

  // Enterprise customers cannot purchase on from Console
  const canPurchaseFromConsole =
    !observabilityIsEnabled && blackfireOrObservabilityIsAvailable;

  return {
    isPurchased, // this feature is bought already and already in use
    blackfireOrObservabilityIsAvailable, // this feature can be activated but does not neccessary mean that it is purchased
    canPurchaseFromConsole, //they can purchase from console
    isEnterprise: observabilityIsEnabled,
    observabilitySuitePurchased: subscription?.observability_suite
  };
};

export default useBlackFireSellableStatus;

export type BlackFireSellableStatusType = ReturnType<
  typeof useBlackFireSellableStatus
>;
